// extracted by mini-css-extract-plugin
export default {"lockedIcon":"locked-otp_lockedIcon__DCZXk","companyName":"locked-otp_companyName__oWeBi"};